// extracted by css-extract-rspack-plugin
var _1 = "App-m_app-bqhlsq0i";
export { _1 as "app" }
